import {
  SAVE_POST_START,
  SAVE_POST_SUCCESS,
  SAVE_POST_FAILURE,
  FETCH_POSTS_START,
  FETCH_POSTS_SUCCESS,
  FETCH_POSTS_FAILURE,
  UPDATE_USER_POST_LIKE,
  UPDATE_USER_POST_COMMENTS,
  UPDATE_USER_POST_COMMENT_COUNT,
  SET_SINGLE_POST,
  FETCH_SINGLE_POST_START,
  FETCH_SINGLE_POST_SUCCESS,
  FETCH_SINGLE_POST_FAILURE,
  DELETE_POST_START,
  DELETE_POST_SUCCESS,
  DELETE_POST_FAILURE,
  CHANGE_POST_STATUS_START,
  CHANGE_POST_STATUS_SUCCESS,
  CHANGE_POST_STATUS_FAILURE,
  PPV_PAYMENT_STRIPE_START,
  PPV_PAYMENT_STRIPE_SUCCESS,
  PPV_PAYMENT_STRIPE_FAILURE,
  PPV_PAYMENT_WALLET_START,
  PPV_PAYMENT_WALLET_SUCCESS,
  PPV_PAYMENT_WALLET_FAILURE,
  SAVE_REPORT_POST_START,
  SAVE_REPORT_POST_SUCCESS,
  SAVE_REPORT_POST_FAILURE,
  FETCH_REPORT_POSTS_START,
  FETCH_REPORT_POSTS_SUCCESS,
  FETCH_REPORT_POSTS_FAILURE,
  PPV_PAYMENT_PAYPAL_START,
  PPV_PAYMENT_PAYPAL_SUCCESS,
  PPV_PAYMENT_PAYPAL_FAILURE,
  UPDATE_SINGLE_POST_LIKES,
  UPDATE_SINGLE_POST_COMMENTS,
  INCREMENT_SINGLE_POST_TIPS_COUNT,
  UPDATE_SINGLE_POST_COMMENTS_COUNT,
  UPDATE_SINGLE_POST_BOOKMARK_STATUS,
  POST_PAYMENT_STRIPE_START,
  POST_PAYMENT_STRIPE_SUCCESS,
  POST_PAYMENT_STRIPE_FAILURE,
  POST_PAYMENT_WALLET_START,
  POST_PAYMENT_WALLET_SUCCESS,
  POST_PAYMENT_WALLET_FAILURE,
  UPDATE_USER_POST_BOOKMARK_STATUS,
  UPDATE_USER_POST_HAS_STORY_STATUS,
  UPDATE_SINGLE_POST_HAS_STORY_STATUS,
  SET_USER_POST,
  UPDATE_POST,
  UPDATE_POST_SUCCESS,
  UPDATE_POST_TRAVELING_LOCATION_START,
  UPDATE_POST_TRAVELING_LOCATION_SUCCESS,
  UPDATE_POST_TRAVELING_LOCATION_FAILURE,
  GENERATE_POST_PREVIEW_START,
  GENERATE_POST_PREVIEW_SUCCESS,
  GENERATE_POST_PREVIEW_FAILURE,
  ACCEPT_POST_COLLABORATION,
  ACCEPT_POST_COLLABORATION_SUCCESS,
  ACCEPT_POST_COLLABORATION_FAILED,
  DECLINE_POST_COLLABORATION,
  DECLINE_POST_COLLABORATION_SUCCESS,
  DECLINE_POST_COLLABORATION_FAILED
} from "./ActionConstant";

export function savePostStart(data) {
  return {
    type: SAVE_POST_START,
    data,
  };
}

export function savePostSuccess(data) {
  return {
    type: SAVE_POST_SUCCESS,
    data,
  };
}

export function savePostFailure(error) {
  return {
    type: SAVE_POST_FAILURE,
    error,
  };
}

export function fetchPostsStart(data) {
  return {
    type: FETCH_POSTS_START,
    data,
  };
}

export function fetchPostsSuccess(data) {
  return {
    type: FETCH_POSTS_SUCCESS,
    data,
  };
}

export function fetchPostsFailure(error) {
  return {
    type: FETCH_POSTS_FAILURE,
    error,
  };
}

export function updateUserPostLikes(data) {
  return {
    type: UPDATE_USER_POST_LIKE,
    data
  }
}

export function updateUserPostComments(data) {
  return {
    type: UPDATE_USER_POST_COMMENTS,
    data
  }
}

export function updateUserPostCommentsCount(data) {
  return {
    type: UPDATE_USER_POST_COMMENT_COUNT,
    data
  }
}

export function updateUserPostBookmarkStatus(data) {
  return {
    type: UPDATE_USER_POST_BOOKMARK_STATUS,
    data
  }
}

export function setSinglePost(data) {
  return {
    type: SET_SINGLE_POST,
    data,
  };
}

export function fetchSinglePostStart(data) {
  return {
    type: FETCH_SINGLE_POST_START,
    data,
  };
}

export function fetchSinglePostSuccess(data) {
  return {
    type: FETCH_SINGLE_POST_SUCCESS,
    data,
  };
}

export function fetchSinglePostFailure(error) {
  return {
    type: FETCH_SINGLE_POST_FAILURE,
    error,
  };
}

export function deletePostStart(data) {
  return {
    type: DELETE_POST_START,
    data,
  };
}

export function deletePostSuccess(data) {
  return {
    type: DELETE_POST_SUCCESS,
    data,
  };
}

export function deletePostFailure(error) {
  return {
    type: DELETE_POST_FAILURE,
    error,
  };
}

export function changePostStatusStart(data) {
  return {
    type: CHANGE_POST_STATUS_START,
    data,
  };
}

export function changePostStatusSuccess(data) {
  return {
    type: CHANGE_POST_STATUS_SUCCESS,
    data,
  };
}

export function changePostStatusFailure(error) {
  return {
    type: CHANGE_POST_STATUS_FAILURE,
    error,
  };
}

export function PPVPaymentStripeStart(data) {
  return {
    type: PPV_PAYMENT_STRIPE_START,
    data,
  };
}

export function PPVPaymentStripeSuccess(data) {
  return {
    type: PPV_PAYMENT_STRIPE_SUCCESS,
    data,
  };
}

export function PPVPaymentStripeFailure(error) {
  return {
    type: PPV_PAYMENT_STRIPE_FAILURE,
    error,
  };
}

// Subscription Payment wallet actions.

export function PPVPaymentWalletStart(data) {
  return {
    type: PPV_PAYMENT_WALLET_START,
    data,
  };
}

export function PPVPaymentWalletSuccess(data) {
  return {
    type: PPV_PAYMENT_WALLET_SUCCESS,
    data,
  };
}

export function PPVPaymentWalletFailure(error) {
  return {
    type: PPV_PAYMENT_WALLET_FAILURE,
    error,
  };
}

export function saveReportPostStart(data) {
  return {
    type: SAVE_REPORT_POST_START,
    data,
  };
}

export function saveReportPostSuccess(data) {
  return {
    type: SAVE_REPORT_POST_SUCCESS,
    data,
  };
}

export function saveReportPostFailure(error) {
  return {
    type: SAVE_REPORT_POST_FAILURE,
    error,
  };
}

export function fetchReportPostsStart(data) {
  return {
    type: FETCH_REPORT_POSTS_START,
    data,
  };
}

export function fetchReportPostsSuccess(data) {
  return {
    type: FETCH_REPORT_POSTS_SUCCESS,
    data,
  };
}

export function fetchReportPostsFailure(error) {
  return {
    type: FETCH_REPORT_POSTS_FAILURE,
    error,
  };
}

export function PPVPaymentPaypalStart(data) {
  return {
    type: PPV_PAYMENT_PAYPAL_START,
    data,
  };
}

export function PPVPaymentPaypalSuccess(data) {
  return {
    type: PPV_PAYMENT_PAYPAL_SUCCESS,
    data,
  };
}

export function PPVPaymentPaypalFailure(error) {
  return {
    type: PPV_PAYMENT_PAYPAL_FAILURE,
    error,
  };
}

export function updateSinglePostLikes(data) {
  return {
    type: UPDATE_SINGLE_POST_LIKES,
    data
  }
}

export function incrementSinglePostTipsCount(data) {
  return {
    type: INCREMENT_SINGLE_POST_TIPS_COUNT,
    data
  }
}


export function updateSinglePostComments(data) {
  return {
    type: UPDATE_SINGLE_POST_COMMENTS,
    data,
  }
}

export function updateSinglePostCommentsCount(data) {
  return {
    type: UPDATE_SINGLE_POST_COMMENTS_COUNT,
    data,
  }
}

export function updateSinglePostBookmarkStatus(data) {
  return {
    type: UPDATE_SINGLE_POST_BOOKMARK_STATUS,
    data,
  }
}

export function updateSinglePostHasStoryStatus(data) {
  return {
    type: UPDATE_SINGLE_POST_HAS_STORY_STATUS,
    data
  }
}

export function postPaymentStripeStart(data) {
  return {
    type: POST_PAYMENT_STRIPE_START,
    data,
  };
}

export function postPaymentStripeSuccess(data) {
  return {
    type: POST_PAYMENT_STRIPE_SUCCESS,
    data,
  };
}

export function postPaymentStripeFailure(error) {
  return {
    type: POST_PAYMENT_STRIPE_FAILURE,
    error,
  };
}

export function postPaymentWalletStart(data) {
  return {
    type: POST_PAYMENT_WALLET_START,
    data,
  };
}

export function postPaymentWalletSuccess(data) {
  return {
    type: POST_PAYMENT_WALLET_SUCCESS,
    data,
  };
}

export function postPaymentWalletFailure(error) {
  return {
    type: POST_PAYMENT_WALLET_FAILURE,
    error,
  };
}

export function updatePostHasStoryStatus(data) {
  return {
    type: UPDATE_USER_POST_HAS_STORY_STATUS,
    data
  }
}

export function updatePost(data) {
  return{
    type: UPDATE_POST,
    data
  }
}

export function updatePostSuccess(data) {
  return {
    type: UPDATE_POST_SUCCESS,
    data
  }
}

export function updatePostTravelingLocationStart(data) {
  return {
    type: UPDATE_POST_TRAVELING_LOCATION_START,
    data,
  }
}

export function updatePostTravelingLocationSuccess(data) {
  return {
    type: UPDATE_POST_TRAVELING_LOCATION_SUCCESS,
    data,
  }
}

export function updatePostTravelingLocationFailure(error) {
  return {
    type: UPDATE_POST_TRAVELING_LOCATION_FAILURE,
    error,
  }
}

export function setUserPost(data) {
  return {
    type: SET_USER_POST,
    data,
  };
}

export function generatePostPreviewStart(data) {
  return {
    type: GENERATE_POST_PREVIEW_START,
    data,
  };
}

export function generatePostPreviewSuccess(data) {
  return {
    type: GENERATE_POST_PREVIEW_SUCCESS,
    data,
  };
}

export function generatePostPreviewFailure(error) {
  return {
    type: GENERATE_POST_PREVIEW_FAILURE,
    error,
  };
}

export function acceptPostCollaboration(payload) {
  return {
    type: ACCEPT_POST_COLLABORATION,
    payload
  };
}

export function acceptPostCollaborationSuccess(payload) {
  return {
    type: ACCEPT_POST_COLLABORATION_SUCCESS,
    payload,
  };
}

export function acceptPostCollaborationFailure(payload) {
  return {
    type: ACCEPT_POST_COLLABORATION_FAILED,
    payload,
  };
}

export function declinePostCollaboration(payload) {
  return {
    type: DECLINE_POST_COLLABORATION,
    payload
  };
}

export function declinePostCollaborationSuccess(payload) {
  return {
    type: DECLINE_POST_COLLABORATION_SUCCESS,
    payload,
  };
}

export function declinePostCollaborationFailure(payload) {
  return {
    type: DECLINE_POST_COLLABORATION_FAILED,
    payload,
  };
}